export const GATEWAY_URL = `https://${process.env.NEXT_PUBLIC_SOCIAL_GATEWAY_DOMAIN_NAME}`;
